exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nh4{\n        font-weight: bold;\n}\n.required-field>label::after {\n    content: '*';\n    color: red;\n    margin-left: 0.25rem;\n}\n.form-control-feedback {\n    font-weight: 100;\n    color: red;\n    position: initial;\n    text-align: left;\n    height: auto;\n    width: auto;\n}\n.has-danger {\n    color: red\n}\n.mt {\n    margin-top: 7px;\n}\n.gradientbt {\n    background: #0F6940;\n    color: white\n}\n.inputwrapper {\n    position: relative;\n}\n.maps {\n    position: absolute;\n    top: 7px;\n    right: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-01801e6e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/segregationPlantTrip/createSegregationTrip.vue
// module id = 113
// module chunks = 0